import { BehaviorSubject } from 'rxjs';

export class Timer {
  private sec: number;
  private min: number;
  private timeout: NodeJS.Timeout;

  timeState$: BehaviorSubject<string>;

  constructor() {
    this.sec = 0;
    this.min = 0;

    this.timeState$ = new BehaviorSubject(this.time);
  }

  private addTime(sec: number): void {
    this.sec = this.sec + sec;

    if (this.sec > 59) {
      this.sec = 0;
      this.min += 1;
    }

    if (this.min > 59) {
      this.min = 0;
    }
  }

  startTimer(start: number) {
    if (this.timeout) {
      return;
    }

    this.timeout = setInterval(() => {
      this.addTime(start);
      this.timeState$.next(this.time);
    }, 1000);
  }

  stopTimer(): void {
    if (!this.timeout) {
      return;
    }

    clearTimeout(this.timeout);
    this.timeout = null;
  }

  get time(): string {
    const strSec = this.sec < 10 ? `0${this.sec}` : `${this.sec}`;
    const strMin = this.min < 10 ? `0${this.min}` : `${this.min}`;

    return `${strMin}:${strSec}`;
  }

  get roundMinutes(): number {
    const minutes = this.sec ? this.min + 1 : this.min;

    return minutes;
  }
}
